export default {
  computed: {
    // By default, if it's not defined in the env, it's 'true'
    $_flinks_isEnabled () {
      const flinksEnabled = process.env.VUE_APP_FLINKS_ENABLED || 'true'
      return flinksEnabled === 'true' || flinksEnabled === undefined
    }
  }
}
